var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"sm","label":_vm.slice.slice_label}},[_c('h2',{staticClass:"header"},[_vm._v(_vm._s(_vm.$prismic.asText(_vm.slice.primary.header)))]),_vm._v(" "),_c('div',{staticClass:"rich-text",domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.slice.primary.text))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }